import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { fetchIntegrations } from "@/features/actions/model/integrationsSlice";
import { fetchTenantConfiguration } from "@/features/app-config/model/tenantConfigurationSlice";
import {
  fetchLearningHistory,
  triggerLearningInsightsGeneration,
} from "@/features/context-hub/model/learningHistorySlice";
import { fetchConnections } from "@/features/data-hub/model/connectionsSlice";
import { fetchDomainById } from "@/features/data-hub/model/domainDetailSlice";
import { fetchDomains } from "@/features/data-hub/model/domainsSlice";
import { fetchNuggets, setNuggetSeverity } from "@/features/nuggets/model/nuggetsSlice";
import { fetchTenants } from "@/features/admin/tenants/model/tenantsSlice";
import { fetchUsers } from "@/features/users/model/usersSlice";
import {
  fetchPublishedAppCategories,
  fetchPublishedApps,
  toggleAppFavorite,
} from "@/features/published-apps/model/publishedAppsSlice";
import { isSessionExpired } from "@/shared/auth/authSession";
import { showApiErrorNotification } from "@/shared/notifications/model/notificationSlice";

export const apiErrorListenerMiddleware = createListenerMiddleware();

apiErrorListenerMiddleware.startListening({
  matcher: isAnyOf(
    fetchConnections.rejected,
    fetchDomainById.rejected,
    fetchDomains.rejected,
    fetchTenantConfiguration.rejected,
    fetchNuggets.rejected,
    // A failed severity save silently reverts the dropdown, which reads as a broken control.
    // `setNuggetReaction.rejected` is deliberately absent — a lost thumb is low-stakes, an explicit
    // triage edit is not.
    setNuggetSeverity.rejected,
    fetchTenants.rejected,
    fetchUsers.rejected,
    fetchPublishedApps.rejected,
    fetchPublishedAppCategories.rejected,
    toggleAppFavorite.rejected,
    fetchIntegrations.rejected,
    fetchLearningHistory.rejected,
    triggerLearningInsightsGeneration.rejected,
  ),
  effect: (_, listenerApi) => {
    // A 401 that expired the refresh token is already redirecting to login;
    // showing a generic error toast underneath that redirect is misleading.
    if (isSessionExpired()) {
      return;
    }
    listenerApi.dispatch(showApiErrorNotification());
  },
});
